import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const errorSelector = createSelector(selfSelector, (trackerStats) => trackerStats.error);

export default errorSelector;
